export enum ConfigActionEnum {
  NONE = 0,
  ADD = 1,
  MODIFY = 2,
  DELETE = 3,
  ENABLE = 4,
  DISABLE = 5,
  STREAM = 6,
}
